import { render } from "./PullDown.vue?vue&type=template&id=54bfece3&scoped=true"
import script from "./PullDown.vue?vue&type=script&lang=js"
export * from "./PullDown.vue?vue&type=script&lang=js"

import "./PullDown.vue?vue&type=style&index=0&id=54bfece3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54bfece3"]])

export default __exports__